import React from 'react';
import { Modal, Tabs } from 'antd';
import AddAssignmentForm from '../Forms/AddAssignmentForm';

const { TabPane } = Tabs;

const AddAssignmentContainer = ({ state, user, ...props }) => {

  return(
    <Modal
      visible={state.showItemContextModal}
      title={props.contextMenuSelection}
      onCancel={props.handleModalCancel}
      footer={[
      ]}
    >
      <AddAssignmentForm
        loading={state.loading} // don't appear to be using right now...
        resource={state.resource}
        itemDetails={state.itemDetails}
        user={user}
        relevantJobs={state.relevantJobs}
        relevantJobsForCostObject={state.relevantJobsForCostObject}
        relatedBranches={state.relatedBranches}
        groupsByBranchAndResource={state.groupsByBranchAndResource}
        servicesByDate={state.servicesByDate}
        activityTypes={state.activityTypes}
        serviceSalaryLevel={state.serviceSalaryLevel}
        servicePrimaryRate={state.servicePrimaryRate}
        serviceJobSalaries={state.serviceJobSalaries}
        confirmDialogue={state.confirmDialogue}
        updateState={props.updateState}
        handleItemDurationChange={props.handleItemDurationChange}
        handleItemStartTimeChange={props.handleItemStartTimeChange}
        handleItemEndTimeChange={props.handleItemEndTimeChange}
        handleOmnibusFieldChange={props.handleOmnibusFieldChange}
        handleCostObjectFilterChange={props.handleCostObjectFilterChange}
        getRelevantJobs={props.getRelevantJobs}
        getRelevantJobsForCostObject={props.getRelevantJobsForCostObject}
        getGroupsByBranchAndResource={props.getGroupsByBranchAndResource}
        getServicesByDate={props.getServicesByDate}
        getActivityTypes={props.getActivityTypes}
        getServiceSalaryLevel={props.getServiceSalaryLevel}
        getServicePrimaryRate={props.getServicePrimaryRate}
        getJobSalariesByService={props.getJobSalariesByService}
        createAssignment={props.createAssignment}
      />
    </Modal>
  )
}

export default AddAssignmentContainer;



// WEBPACK FOOTER //
// ./src/Components/Schedule/LiveScheduleUpdate/FormContainers/AddAssignmentContainer.js